export const DTMF_COMMANDS = {
    muteAudio: {
        toggle: '2',
        secondaryToggle: '*6', // Альтернативный вариант по просьбе Автоваза
    },
    muteVideo: {
        toggle: '7',
    },
    hand: {
        toggle: '3',
    },
    gridView: {
        toggle: '5',
    },
    commandList: {
        open: '1',
    },
    participantList: {
        open: '6',
        prevPage: '4',
        nextPage: '6',
    },
    debug: {
        open: '99999',
        halt: '0',
        drawConference: {
            toggle: '1',
        },
    },
    pagination: {
        prevPage: '4',
        nextPage: '6',
    },
    common: {
        close: '*',
    },
};
